module.exports = __webpack_public_path__ + "static/media/Инструментальная Зона Отдыха - Физическое восстановление.77f46a77.mp3";